var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.985,
    height: 13.652,
    viewBox: "0 0 56.985 13.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3164",
    "data-name": "Grupo 3164",
    transform: "translate(-145.624 -2108.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3161",
    "data-name": "Grupo 3161",
    transform: "translate(145.624 2108.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(5.483 5.483)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3162",
    "data-name": "Grupo 3162",
    transform: "translate(167.291 2108.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_45",
    "data-name": "L\\xEDnea 45",
    x2: 7.208,
    transform: "translate(3.222 6.826)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3163",
    "data-name": "Grupo 3163",
    transform: "translate(188.957 2108.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.826,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.826,
    cy: 6.826,
    r: 6.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286",
    "data-name": "Grupo 286",
    transform: "translate(2.816 2.816)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_46",
    "data-name": "L\\xEDnea 46",
    y2: 8.02,
    transform: "translate(4.01)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_47",
    "data-name": "L\\xEDnea 47",
    x1: 8.02,
    transform: "translate(0 4.01)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowIcons);
export default __webpack_public_path__ + "static/media/window_icons.7ac0dc2b14586d03640e517560eedf99.svg";
export { ForwardRef as ReactComponent };